import { CompanyConstant } from "presentation/constant/Company/CompanyConstant";
import { ActiveIndDroOpts } from "presentation/constant/DropDownOptions/Common/ActiveIndDroOpts";
import { useCompanyMaintenanceVM } from "presentation/hook/Company/useCompanyMaintenanceVM";

import { useCompanyMaintenanceTracked } from "presentation/store/Company/CompanyMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

const CompanySearchForm = () => {
    const [companyState] = useCompanyMaintenanceTracked();
    const companyMaintenanceVM = useCompanyMaintenanceVM();
    const COMPANY_CONST = CompanyConstant.Header;
    const companySearchCriteria = companyState.searchCriteria;

    const onInputTextChange = useCallback((e: any, fieldName: string) => {
        const fieldValue = e.target.value;
        companyMaintenanceVM.onInputTextChange(fieldName, fieldValue);
    }, [companyMaintenanceVM]);

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                width={'150px'}
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={companySearchCriteria.companyCode || ''}
                fieldValue={companySearchCriteria.companyCode}
                fieldLabel={COMPANY_CONST.COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'companyCode'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyMaintenanceVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_CONST.COMPANY_CODE, companyMaintenanceVM, companySearchCriteria.companyCode])

    const memoCompanyName = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={companySearchCriteria.companyName || ''}
                fieldValue={companySearchCriteria.companyName}
                fieldLabel={COMPANY_CONST.COMPANY_NAME}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'companyName'}
                maxLength={50}
                isTextFieldCapitalize={false}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyMaintenanceVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COMPANY_CONST.COMPANY_NAME, companyMaintenanceVM, companySearchCriteria.companyName])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "150px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={companySearchCriteria?.activeInd ?? ""}
                fieldValue={companySearchCriteria?.activeInd}
                fieldLabel={COMPANY_CONST.ACTIVE_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'activeInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyMaintenanceVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [COMPANY_CONST.ACTIVE_IND, companySearchCriteria.activeInd, companyMaintenanceVM])

    const memoCompanyType = useMemo(() =>
        <div className='flex-row-item' style={{ width: "330px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={companySearchCriteria?.companyType?.join(',')}
                fieldValue={companySearchCriteria?.companyType}
                fieldLabel={COMPANY_CONST.COMPANY_TYPE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyType'}
                maxLength={60}
                isMultipleDropDown={true}
                options={companyState.dynamicOptions.companyTypeForSearchDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    companyMaintenanceVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [COMPANY_CONST.COMPANY_TYPE, companySearchCriteria.companyType, companyMaintenanceVM, companyState.dynamicOptions.companyTypeForSearchDropdownOptions])


    return <>

        <CriteriaItemContainer>
            {companyState.enabledSearchCriteria.companyCode ? memoCompanyCode : null}
            {companyState.enabledSearchCriteria.companyName ? memoCompanyName : null}
        </CriteriaItemContainer>

        <CriteriaItemContainer>
            {memoCompanyType}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {companyState.enabledSearchCriteria.activeInd ? memoActiveInd : null}
        </CriteriaItemContainer>

    </>;
}
export default memo(CompanySearchForm);